import React from 'react';
import { ErrorDisplayProvider } from '../../context';
import { ReportEventFormContent } from './ReportEventFormContent';
import { ReportEventFormDisplay } from './ReportEventFormDisplay';
import { RadioGroup } from './ReportRadios';

export const ReportEventForm = (props: {
    eventId: string;
    country: string;
    eventName: string;
    eventUrl: string;
    helpCenterLanguage: string;
    userCountry: string;
}) => {
    const {
        eventId,
        country,
        eventName,
        eventUrl,
        helpCenterLanguage,
        userCountry,
    } = props;

    return (
        <ErrorDisplayProvider error={false}>
            <ReportEventFormContent>
                <RadioGroup
                    defaultSelection="reason_refund"
                    country={country}
                    userCountry={userCountry}
                >
                    <ReportEventFormDisplay
                        eventId={eventId}
                        eventName={eventName}
                        eventUrl={eventUrl}
                        helpCenterLanguage={helpCenterLanguage}
                        country={country}
                        userCountry={userCountry}
                    />
                </RadioGroup>
            </ReportEventFormContent>
        </ErrorDisplayProvider>
    );
};
